<div fxLayout="row wrap" fxLayoutAlign="space-between center" class="m-b-15">
    <div fxLayout="row wrap">
        <mat-icon class="m-r-10">list</mat-icon>
        <div class="title">Activity</div>
    </div>
    <div>
        <button *ngIf="activities.length" class="m-r-10" type="button" (click)="hideShowDetails()" mat-raised-button color="primary">
            <span *ngIf="!isShowActivities">Show Details</span>
            <span *ngIf="isShowActivities">Hide Details</span>
        </button>
    </div>
</div>
<div fxLayout="row wrap" class="m-b-20">
    <div [matTooltip]="loggedInUser.name">
        <ngx-avatar size="40" [name]="loggedInUser.name" bgColor="#bcbfbf" initialsSize="2"></ngx-avatar>
    </div>
    <div fxFlex="60">
        <form [formGroup]="activityForm">
            <mat-card class="activity m-t-0">
                <div fxLayout="row">
                    <textarea class="inputBox h-30" placeholder="Write a comment..." formControlName="noteText"
                        (focus)="focusIn($event)" (focusout)="focusOut($event)"></textarea>
                </div>
                <div *ngIf="isShowActivitySaveBtn" class="m-t-10" @fadeIn>
                    <button [disabled]="!activityForm.get('noteText').value" type="button" (click)="saveNote()"
                        mat-raised-button color="primary">Save</button>
                </div>
            </mat-card>
        </form>
    </div>
</div>
<div *ngIf="isShowActivities" @fadeIn>
    <div fxLayout="row wrap" class="m-b-20" *ngFor="let item of activities">
            <div fxFlex="3.5" class="m-r-15">
                <ngx-avatar [matTooltip]="item.authorName" size="40" [name]="item.authorName" bgColor="#bcbfbf" initialsSize="2"></ngx-avatar>
            </div>
            <div fxFlex="57">
                <div fxLayout="row wrap">
                    <div class="author-name m-r-10">{{item.authorName}}</div>
                    <div>{{getDisplayDate(item.meta.lastUpdated)}}</div>
                </div>
                <div fxLayout="row wrap" *ngIf="item.isEdit">
                    <mat-card fxFlex="100" class="activity m-l-0 m-b-10 m-t-5">
                        <div fxLayout="row">
                            <textarea class="inputBox" 
                                [(ngModel)]="item.noteText"
                                [readonly]="!item.isEdit"
                                placeholder="Write a comment..."></textarea>
                        </div>
                        <div class="m-t-10" fxLayoutAlign="start center" *ngIf="item.isEdit">
                            <button class="m-r-15" [disabled]="!item.noteText" type="button"
                                (click)="editNote(item)" mat-raised-button color="primary">Save</button>
                            <mat-icon class="pointer" (click)="closeEdit(item)">close</mat-icon>
                        </div>
                    </mat-card>
                </div>
                <div fxLayout="row wrap" *ngIf="!item.isEdit">
                    <mat-card class="activity lable m-l-0 m-b-10 m-t-5">{{item.noteText}}</mat-card>
                </div>
                <div fxLayout="row wrap" *ngIf="!item.isEdit">
                    <a class="pointer" (click)="onEditClick(item)"><u>Edit</u></a>
                </div>
            </div>
    </div>
</div>